<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ADWrY9/images/e9781439633861_cover.jpg?1684305910099" alt="This image is the cover for the book Lost Trolleys of Queens and Long Island, Images of Rail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Trolleys of Queens and Long Island, Images of Rail
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Before subways and trains, Queens and Long Island were reachable via a large number of electric trolley lines.</b></p><br/><p>An amazing assortment of electric trolley lines once traversed the towns and villages of Queens and Long Island. With names like Jamaica Central, Northport Traction, Ocean Electric, and the Steinway lines, some meandered across meadows and hills while others sped over elevated tracks. There was even one line that had streetcars but no tracks. In the end, all of them helped stitch the countryside into the concentrated suburban area it is today--with barely a trace of the trolleys left anywhere.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen L. Meyers
      </h2>
      
      <p class="authorDescription body article">In Lost Troll eys of Qu een s an d Long Isl an d, Stephen L. Meyers gives t hese lines--more than 20 of them--new life. With exceptional images and fascinating detail about things like the tiny storage battery cars and the trolleys that met all the trains, he traces the streetcar era from the late 1800s to the mid-1930s. The author of Manhattan's Lost Streetcars, he is a longtime member of the Electric Railroaders' Association in New York and other rail groups.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32569434